import { Box, FormField } from '@costar/theme-ui';
import Autocomplete from '@costar/theme-ui-autocomplete';
import React, { forwardRef, useMemo, useCallback } from 'react';
import { NULL_RANGE } from './constants.esm.js';
import { defaultTimeFrameOptions } from './types.esm.js';
import { addMonthsToNow, subMonthsToNow, addYearsToNow, subYearsToNow } from '../../utils/dates.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
var TimeFrameDropDown = /*#__PURE__*/forwardRef(function TimeFrameDropDown(props, _ref) {
  var _props$label = props.label,
    label = _props$label === void 0 ? 'Sold within the last' : _props$label,
    _value = props.value,
    _props$options = props.options,
    _options = _props$options === void 0 ? defaultTimeFrameOptions : _props$options,
    onChange = props.onChange,
    isInFuture = props.isInFuture,
    _props$timeFrameDropd = props.timeFrameDropdownPlaceholder,
    timeFrameDropdownPlaceholder = _props$timeFrameDropd === void 0 ? 'Select' : _props$timeFrameDropd,
    fontSize = props.fontSize,
    fontFamily = props.fontFamily;
  var options = useMemo(function () {
    return Object.keys(_options).map(function (k) {
      return {
        value: k,
        label: _options[k].label,
        sortOrder: _options[k].sortOrder
      };
    }).sort(function (a, b) {
      return a.sortOrder - b.sortOrder;
    });
  }, [_options]);
  var value = options.find(function (i) {
    return i.value === _value;
  });
  var handleSelectionOnChange = useCallback(function (_event, value) {
    if (!value) {
      onChange(NULL_RANGE);
      return;
    }
    if (value) {
      var Ranges = {
        threeMonths: isInFuture ? addMonthsToNow(3) : subMonthsToNow(3),
        sixMonths: isInFuture ? addMonthsToNow(6) : subMonthsToNow(6),
        oneYear: isInFuture ? addYearsToNow(1) : subYearsToNow(1),
        twoYears: isInFuture ? addYearsToNow(2) : subYearsToNow(2),
        threeYears: isInFuture ? addYearsToNow(3) : subYearsToNow(3),
        fourYears: isInFuture ? addYearsToNow(4) : subYearsToNow(4),
        fiveYears: isInFuture ? addYearsToNow(5) : subYearsToNow(5),
        tenYears: isInFuture ? addYearsToNow(10) : subYearsToNow(10)
      };
      var val = Ranges[value.value].toISOString();
      var min = isInFuture ? null : val;
      var max = isInFuture ? val : null;
      var payload = {
        minValue: min,
        maxValue: max
      };
      onChange(payload);
    }
  }, [isInFuture, onChange]);
  var componentsProps = useMemo(function () {
    return {
      listbox: {
        disablePadding: true,
        fontSize: fontSize,
        fontFamily: fontFamily
      }
    };
  }, [fontSize, fontFamily]);
  return /*#__PURE__*/React.createElement(Box, {
    className: "time-frame-dropdown-container",
    pt: "xxl",
    pb: "md",
    px: "md"
  }, /*#__PURE__*/React.createElement(FormField, {
    label: label
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    mode: "select",
    options: options,
    value: value !== null && value !== void 0 ? value : undefined,
    placeholder: timeFrameDropdownPlaceholder,
    fixToInputWidth: true,
    fullWidthPopover: true,
    componentsProps: componentsProps,
    onChange: handleSelectionOnChange
  })));
});

export default TimeFrameDropDown;
//# sourceMappingURL=time-frame-dropdown.esm.js.map
